"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = parse;
exports.getLanguage = getLanguage;
exports.getCountry = getCountry;
exports.getScript = getScript;
exports.getVariant = getVariant;
exports.getKeyword = getKeyword;
exports.normalize = normalize;
exports.normalizeAcceptLanguage = normalizeAcceptLanguage;
exports.prepareSupported = prepareSupported;
exports.getBest = getBest;

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _debug = _interopRequireDefault(require("debug"));

// flow
var log = (0, _debug.default)('locale-id'); // http://userguide.icu-project.org/locale

function parse(locale) {
  if (!locale) {
    return undefined;
  } // extract keyword


  var stringLocale = String(locale);
  var keywordPos = stringLocale.indexOf('@');
  var keyword = keywordPos !== -1 ? stringLocale.substr(keywordPos + 1) : undefined;
  var localeWithoutKeyword = keywordPos !== -1 ? stringLocale.substr(0, keywordPos) : stringLocale; // en-us => en_us

  var parts = String(localeWithoutKeyword).replace(/-/g, '_').split('_');

  if (!parts.length || parts.length > 4) {
    return undefined;
  }

  var language = parts.shift();

  if (!language) {
    return undefined;
  }

  var retVar = {
    keyword: keyword,
    language: language.toLowerCase()
  };

  if (!parts.length) {
    return retVar;
  }

  if (parts.length === 3) {
    var variant = parts.pop();

    if (variant) {
      retVar.variant = variant.toUpperCase();
    }
  }

  var country = parts.pop();

  if (country.length > 3) {
    retVar.keyword = country;
    country = parts.pop();
  }

  if (country) {
    retVar.country = country.toUpperCase();
  }

  if (!parts.length) {
    return retVar;
  }

  var script = parts.pop();

  if (script) {
    retVar.script = (0, _capitalize.default)(script.toLowerCase());
  }

  return retVar;
}

function getLanguage(locale) {
  var obj = parse(locale);
  return obj && obj.language;
}

function getCountry(locale) {
  var obj = parse(locale);
  return obj && obj.country;
}

function getScript(locale) {
  var obj = parse(locale);
  return obj && obj.script;
}

function getVariant(locale) {
  var obj = parse(locale);
  return obj && obj.variant;
}

function getKeyword(locale) {
  var obj = parse(locale);
  return obj && obj.keyword;
}

function normalize(locale, delimeter) {
  if (delimeter === void 0) {
    delimeter = '_';
  }

  var obj = parse(locale);

  if (!obj) {
    return obj;
  }

  var result = obj.language;

  if (obj.script) {
    result += "" + delimeter + obj.script;
  }

  if (obj.country) {
    result += "" + delimeter + obj.country;
  }

  return result;
}

var splitAcceptLanguageRegEx = /([a-z]{1,8}(-[a-z]{1,8})?)\s*(;\s*q\s*=\s*(1|0\.[0-9]+))?/ig;
var acceptLanguageItemRegEx = /^([a-z]{1,8}(-[a-z]{1,8})?)/i;

function normalizeAcceptLanguage(acceptLanguage) {
  var returnItems = [];

  if (!acceptLanguage) {
    return returnItems;
  }

  var items = acceptLanguage.match(splitAcceptLanguageRegEx) || [];
  (0, _forEach.default)(items, function (acceptLanguageItem) {
    var matches = acceptLanguageItem.match(acceptLanguageItemRegEx) || [];
    var locale = normalize(matches[0]);

    if (locale) {
      returnItems.push(locale);
    }
  });
  return returnItems;
}

function prepareSupported(supported) {
  var lgs = {};
  (0, _forEach.default)(supported, function (supportedLocale) {
    var _parse = parse(supportedLocale),
        language = _parse.language,
        country = _parse.country;

    if (!language) {
      throw new Error("Locale " + supportedLocale + " is not parsable");
    }

    if (!lgs[language]) {
      lgs[language] = {
        countries: {},
        firstCountry: undefined,
        main: undefined
      };
    }

    var lg = lgs[language];

    if (country) {
      lg.countries[country] = supportedLocale;

      if (!lg.firstCountry) {
        lg.firstCountry = supportedLocale;
      }
    } else {
      lg.main = supportedLocale;
    }
  });
  return lgs;
}

function getBest(supported, locale, defaultLocale, getAnyCountry) {
  var lgs = (0, _isArray.default)(supported) ? prepareSupported(supported) : supported; // return defaultLocale if current locale is undefined

  if (!locale && defaultLocale) {
    return getBest(supported, defaultLocale, undefined, getAnyCountry);
  }

  if (!locale) {
    log("Locale " + locale + " is not supported");
    return undefined;
  }

  var _parse2 = parse(locale),
      language = _parse2.language,
      country = _parse2.country;

  if (!language) {
    return defaultLocale;
  } // selected locale is not supported


  if (!lgs[language]) {
    log("Locale " + locale + " is not supported");

    if (locale === defaultLocale) {
      return undefined;
    }

    return getBest(supported, defaultLocale, null, getAnyCountry);
  }

  var _lgs$language = lgs[language],
      countries = _lgs$language.countries,
      _lgs$language$main = _lgs$language.main,
      main = _lgs$language$main === void 0 ? defaultLocale : _lgs$language$main,
      firstCountry = _lgs$language.firstCountry;

  if (!countries || !country) {
    if (getAnyCountry && firstCountry) {
      return firstCountry;
    }

    return main;
  }

  if (getAnyCountry && firstCountry) {
    return countries[country] ? countries[country] : firstCountry;
  }

  return countries[country] ? countries[country] : main;
}
//# sourceMappingURL=index.js.map